import "./ActionConfirmation.css";
import React, { Fragment } from "react";
import { Box, Modal, Typography } from "@mui/material";

const ActionConfirmation = ({
  title,
  description,
  openDialog,
  handleCloseDialog,
}) => {
  return (
    <Fragment>
      <Modal
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="confirmation-modal-container">
          <Typography id="modal-modal-title" className="title">
            {title}
          </Typography>
          <Typography id="modal-modal-description" className="description">
            {description}
          </Typography>

          <Box className="buttons-container">
            <button className="cancel-btn" onClick={handleCloseDialog}>
              Cancel
            </button>
            <button
              className="confirm-btn"
              onClick={() => handleCloseDialog(true)}
            >
              Confirm
            </button>
          </Box>
        </Box>
      </Modal>
    </Fragment>
  );
};

export default ActionConfirmation;
